import { render, staticRenderFns } from "./FoldButton.vue?vue&type=template&id=10d6441e&scoped=true"
import script from "./FoldButton.vue?vue&type=script&lang=js"
export * from "./FoldButton.vue?vue&type=script&lang=js"
import style0 from "./FoldButton.vue?vue&type=style&index=0&id=10d6441e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6441e",
  null
  
)

export default component.exports